import React from 'react';
import { fmtPrice, fmtUsd } from '../utils/fmtPrice';
import { orderSideDisplayLabel, resolveOrderAction, sideLabelCssClass } from '../utils/tradeActionUi';
import './OrderTransactionsSection.css';

const VISIBLE_ROWS = 10;

function fmtOrderTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso.includes('T') ? iso : `${iso.replace(' ', 'T')}Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}

export default function OrderTransactionsSection({
  orders = [],
  title = 'Order Transactions',
  hint = 'Recent filled and submitted orders for your account.',
  visibleRows = VISIBLE_ROWS,
}) {
  const scrollStyle = { maxHeight: `${38 + visibleRows * 38}px` };

  return (
    <section className="order-transactions-section obot-card">
      <h2>{title}</h2>
      <p className="order-transactions-hint">{hint}</p>

      {!orders.length ? (
        <p className="order-transactions-empty">No order transactions yet.</p>
      ) : (
        <>
          <div className="order-transactions-table-wrap order-transactions-scroll" style={scrollStyle}>
            <table className="obot-table order-transactions-table obot-table-stack-mobile">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Order</th>
                  <th>Symbol</th>
                  <th>Action</th>
                  <th>USD</th>
                  <th>Price</th>
                  <th>Status</th>
                  <th>Source</th>
                  <th>Paper</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => {
                  const action = resolveOrderAction(o);
                  const actionLabel = orderSideDisplayLabel(o);
                  const actionClass = sideLabelCssClass(o.side, action);
                  return (
                  <tr key={o.id}>
                    <td data-label="Time">{fmtOrderTime(o.created_at)}</td>
                    <td data-label="Order">#{o.id}</td>
                    <td data-label="Symbol">{o.symbol}</td>
                    <td data-label="Action" className={actionClass}>
                      {actionLabel}
                    </td>
                    <td data-label="USD">{fmtUsd(o.size_usd)}</td>
                    <td data-label="Price">{fmtPrice(o.limit_price)}</td>
                    <td data-label="Status">{o.status}</td>
                    <td data-label="Source">{o.signal_source || '—'}</td>
                    <td data-label="Paper">{o.is_paper ? 'yes' : 'no'}</td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="order-transactions-meta">
            {orders.length} transaction{orders.length === 1 ? '' : 's'} — first{' '}
            {Math.min(visibleRows, orders.length)} visible, scroll for more
          </p>
        </>
      )}
    </section>
  );
}
